export const isProd = false;
export const COOKIE_USER = 'user';
export const COOKIE_REFRESH_TOKEN = 'refresh_token';
export const LOCAL_STORAGE_OTP_EMAIL = 'otpEmail';
export const LOCAL_STORAGE_OTP_RESEND_SECOND = 'otpResendSecond';
export const RESEND_OTP_SECOND = 60;
